"use strict";

var _regeneratorRuntime = require("/var/www/dev/prosper/admin.samsung-prosper.dev.pannovate.net/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _LastFiveTransactions = _interopRequireDefault(require("../../components/LastFiveTransactions"));

var _index = require("../../../../index");

var _CardModel = _interopRequireDefault(require("../../../../modules/cards/models/CardModel"));

var _ModalDialog = _interopRequireDefault(require("../../../../components/modal/ModalDialog"));

var _NumberHelper = _interopRequireDefault(require("../../../../util/NumberHelper"));

var _reactRouter = require("react-router");

var _ConfirmationModalDialog = _interopRequireDefault(require("../../../../components/modal/ConfirmationModalDialog"));

var _AppButtonModal = _interopRequireDefault(require("../../../../components/modal/AppButtonModal"));

var _UnloadForm = _interopRequireDefault(require("../../../../modules/cards/UnloadForm"));

var _LoadForm = _interopRequireDefault(require("../../../../modules/cards/LoadForm"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var CardBasicInfo = /*#__PURE__*/function (_Component) {
  _inherits(CardBasicInfo, _Component);

  function CardBasicInfo(props) {
    var _this;

    _classCallCheck(this, CardBasicInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CardBasicInfo).call(this, props));
    _this.state = {
      loading: false,
      showStolenModal: false,
      showStatusModal: false,
      changingStatusInProgress: false,
      changeStatusMessage: "",
      regenerationMessage: "",
      reissueStatus: "lost",
      cardStatus: props.card.status,
      show3DSModal: false,
      showConfirmationDialog: false,
      confirmationDialogContent: ""
    };
    return _this;
  }

  _createClass(CardBasicInfo, [{
    key: "_changeCardLockStatus",
    value: function _changeCardLockStatus(card, val) {
      var _this2 = this;

      this.setState({
        loading: true
      });
      new _CardModel["default"]().changeFreezeStatus(card, val).then(function () {
        _this2.setState({
          loading: false
        }); // this._fetcher.refresh();


        window.location.reload();
      })["catch"](function () {});
    }
  }, {
    key: "_changeStolenStatus",
    value: function () {
      var _changeStolenStatus2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(card) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new _CardModel["default"]().changeStolenStatus(card);

              case 2:
                this.onClose(); // this._fetcher.refresh();

                window.location.reload();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _changeStolenStatus(_x) {
        return _changeStolenStatus2.apply(this, arguments);
      }

      return _changeStolenStatus;
    }()
  }, {
    key: "_changeCardStatus",
    value: function () {
      var _changeCardStatus2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(card) {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  changingStatusInProgress: true,
                  changeStatusMessage: ""
                });
                _context2.prev = 1;
                _context2.next = 4;
                return new _CardModel["default"]().changeCardStatus(card.id, this.state.cardStatus);

              case 4:
                result = _context2.sent;

                if (result) {
                  window.location.reload();
                }

                this.onStatusClose();
                this.setState({
                  regeneratingInProgress: false
                });
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](1);
                this.setState({
                  changingStatusInProgress: false,
                  changeStatusMessage: _context2.t0.message
                }, function () {
                  setTimeout(function () {});
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 10]]);
      }));

      function _changeCardStatus(_x2) {
        return _changeCardStatus2.apply(this, arguments);
      }

      return _changeCardStatus;
    }()
  }, {
    key: "_regenerateCard",
    value: function () {
      var _regenerateCard2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(card) {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  regeneratingInProgress: true,
                  regenerationMessage: ""
                });
                _context3.prev = 1;
                _context3.next = 4;
                return new _CardModel["default"]().regenerateCard(card, card.status !== "stolen" ? this.state.reissueStatus : "stolen");

              case 4:
                result = _context3.sent;

                if (!result) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", this.props.history.push("/cards/details/" + result.id));

              case 7:
                this.onClose(); //this._fetcher.refresh();
                // window.location.reload();

                this.setState({
                  regeneratingInProgress: false
                });
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](1);
                this.setState({
                  regeneratingInProgress: false,
                  regenerationMessage: _context3.t0.message
                }, function () {
                  setTimeout(function () {});
                });

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 11]]);
      }));

      function _regenerateCard(_x3) {
        return _regenerateCard2.apply(this, arguments);
      }

      return _regenerateCard;
    }()
  }, {
    key: "handleUpdate3DSSubmit",
    value: function () {
      var _handleUpdate3DSSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(card) {
        var result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return new _CardModel["default"]().update3DS(card.id);

              case 3:
                result = _context4.sent;
                this.setState({
                  show3DSModal: false
                });

                if (result) {
                  // window.location.reload();
                  this.showConfirmationDialog("You have succesfully update 3DS.");
                }

                _context4.next = 12;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);
                console.log("Unexpected error:", _context4.t0);
                this.showConfirmationDialog("Updating 3DS failed.");

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8]]);
      }));

      function handleUpdate3DSSubmit(_x4) {
        return _handleUpdate3DSSubmit.apply(this, arguments);
      }

      return handleUpdate3DSSubmit;
    }()
  }, {
    key: "showConfirmationDialog",
    value: function showConfirmationDialog(content) {
      this.setState({
        showConfirmationDialog: true,
        confirmationDialogContent: content
      });
    }
  }, {
    key: "_reissueStatusChanged",
    value: function _reissueStatusChanged(e) {
      this.setState({
        reissueStatus: e.target.value
      });
    }
  }, {
    key: "_statusChanged",
    value: function _statusChanged(e) {
      this.setState({
        cardStatus: e.target.value
      });
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.setState({
        showStolenModal: false,
        regenerationMessage: ""
      });
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.setState({
        showStolenModal: true
      });
    }
  }, {
    key: "openStatusModal",
    value: function openStatusModal() {
      this.setState({
        showStatusModal: true
      });
    }
  }, {
    key: "onStatusClose",
    value: function onStatusClose() {
      this.setState({
        showStatusModal: false,
        changeStatusMessage: ""
      });
    }
  }, {
    key: "getLoadButton",
    value: function getLoadButton() {
      var _this3 = this;

      return _react["default"].createElement(_AppButtonModal["default"], {
        buttonText: "Load",
        buttonClassName: "button-success remove-radius-right"
      }, _react["default"].createElement(_LoadForm["default"], {
        card: this.props.card,
        onLoad: function onLoad() {
          return _this3.props.refresh();
        }
      }));
    }
  }, {
    key: "getUnloadButton",
    value: function getUnloadButton() {
      var _this4 = this;

      return _react["default"].createElement(_AppButtonModal["default"], {
        buttonText: "Unload",
        buttonClassName: "button-danger remove-radius-left"
      }, _react["default"].createElement(_UnloadForm["default"], {
        card: this.props.card,
        onLoad: function onLoad() {
          return _this4.props.refresh();
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var card = this.props.card;
      var status = "ACTIVE";

      switch (card.status) {
        case "pending_activation":
          status = "PENDING ACTIVATION";
          break;

        case "active":
          status = "ACTIVE";
          break;

        case "locked":
          status = "LOCKED";
          break;

        case "stolen":
          status = "STOLEN";
          break;

        default:
          status = card.status ? card.status.toUpperCase() : "UNKNOWN";
      }

      if (card.locked) {
        status = "LOCKED";
      }

      return _react["default"].createElement("div", null, _react["default"].createElement("div", {
        className: "row"
      }, this.state.loading === true ? _react["default"].createElement(_index.LoadingOverlay, null) : null, _react["default"].createElement("div", {
        className: "col-xl-12"
      }, _react["default"].createElement("div", {
        className: "element-with-blur"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "box-header marginless"
      }, _react["default"].createElement("h2", null, _react["default"].createElement("i", {
        className: "fa fa-credit-card"
      }), " Card Summary")), _react["default"].createElement("div", {
        className: "box-body text-white padded"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-sm-6"
      }, _react["default"].createElement("dl", null, _react["default"].createElement("dt", null, _react["default"].createElement("h3", null, "Balance:")), _react["default"].createElement("dd", null, _react["default"].createElement("h3", null, _NumberHelper["default"].currency(card.balance, card.currency))), _react["default"].createElement("dt", null, "Type:"), _react["default"].createElement("dd", null, card.type), _react["default"].createElement("dt", null, "Category:"), _react["default"].createElement("dd", null, card.category), _react["default"].createElement("dt", null, "Expires:"), _react["default"].createElement("dd", null, card.expires == null ? "/" : card.expires), _react["default"].createElement("dt", null, "PAN:"), _react["default"].createElement("dd", null, card.pan), _react["default"].createElement("dt", null, "Token:"), _react["default"].createElement("dd", null, card.publicToken), _react["default"].createElement("dt", null, "Status:"), _react["default"].createElement("dd", null, status), _react["default"].createElement("dt", null, "3DS mobile number:"), _react["default"].createElement("dd", null, card.mobile || "-"))), _react["default"].createElement("div", {
        className: "col-sm-4 text-center"
      }, _react["default"].createElement("img", {
        src: "/img/card-orders.png",
        alt: ""
      })), _react["default"].createElement("div", {
        className: "col-sm-2 text-right"
      }, _react["default"].createElement("div", {
        style: {
          maxWidth: "200px"
        }
      }, status === "STOLEN" ? _react["default"].createElement("span", null, _react["default"].createElement("button", {
        onClick: function onClick() {
          return _this5.openModal();
        },
        className: "button-danger btn-block"
      }, "Replace Card")) : _react["default"].createElement("span", null, _react["default"].createElement("div", {
        className: "lockCardWrapper",
        style: {
          margin: "20px 0 20px 5px"
        }
      }, _react["default"].createElement("p", {
        style: {
          margin: 0
        }
      }, "Lock Card:"), _react["default"].createElement(_index.SwitchButton, {
        onChange: function onChange(val) {
          return _this5._changeCardLockStatus(card, val);
        },
        isChecked: !!card.locked || card.status === "locked"
      })), _react["default"].createElement("button", {
        onClick: function onClick() {
          return _this5.openStatusModal();
        },
        className: "button-info btn-block"
      }, "Change Status"), _react["default"].createElement("button", {
        onClick: function onClick() {
          return _this5.openModal();
        },
        className: "button-danger btn-block"
      }, "Lost/Stolen Card"), _react["default"].createElement("div", {
        className: "btn-block",
        style: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }
      }, this.getLoadButton(), this.getUnloadButton()), _react["default"].createElement("button", {
        onClick: function onClick() {
          return _this5.setState({
            show3DSModal: true
          });
        },
        className: "button-info btn-block"
      }, "Update 3DS"))))))), _react["default"].createElement("div", {
        className: "row",
        style: {
          marginTop: "20px"
        }
      }, _react["default"].createElement("div", {
        className: "col-xl-12"
      }, _react["default"].createElement(_LastFiveTransactions["default"], {
        card: this.props.card
      }))))), _react["default"].createElement(_ConfirmationModalDialog["default"], {
        show: this.state.show3DSModal,
        text: "The Payment Device with PAN " + this.props.card.pan + " will be enroled in 3DS using following phone number " + this.props.card.mobile + ". Please confirm.",
        onModalClose: function onModalClose() {
          return _this5.setState({
            show3DSModal: false
          });
        },
        onSubmit: function onSubmit() {
          return _this5.handleUpdate3DSSubmit(_this5.props.card);
        }
      }), _react["default"].createElement(_ConfirmationModalDialog["default"], {
        show: this.state.showConfirmationDialog,
        text: this.state.confirmationDialogContent,
        cancelButton: null,
        submitButton: "OK",
        onModalClose: function onModalClose() {
          return _this5.setState({
            showConfirmationDialog: false
          });
        },
        onSubmit: function onSubmit() {
          return _this5.setState({
            showConfirmationDialog: false
          });
        }
      }), _react["default"].createElement(_ModalDialog["default"], {
        show: this.state.showStolenModal,
        onClose: this.onClose.bind(this)
      }, this.state.regeneratingInProgress ? _react["default"].createElement(_index.LoadingOverlay, null) : null, _react["default"].createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column"
        }
      }, _react["default"].createElement("p", {
        style: {
          textAlign: "center",
          paddingBottom: 20
        }
      }, "This action will reissue new card for the user."), card.status !== "stolen" ? _react["default"].createElement("p", null, "Please select the status of the old card:") : null, card.status !== "stolen" ? _react["default"].createElement("div", {
        style: {
          width: 250,
          marginBottom: 20
        }
      }, _react["default"].createElement("select", {
        value: this.state.reissueStatus,
        className: "form-control",
        onChange: function onChange(e) {
          return _this5._reissueStatusChanged(e);
        }
      }, _react["default"].createElement("option", {
        value: "lost"
      }, "Lost"), _react["default"].createElement("option", {
        value: "stolen"
      }, "Stolen (irreversible!)"))) : null, _react["default"].createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      }, _react["default"].createElement("button", {
        onClick: this.onClose.bind(this),
        className: "button-info"
      }, "Cancel"), _react["default"].createElement("button", {
        onClick: function onClick() {
          return _this5._regenerateCard(card);
        },
        className: "button-info"
      }, "Submit")), this.state.regenerationMessage ? _react["default"].createElement("div", null, this.state.regenerationMessage) : null)), _react["default"].createElement(_ModalDialog["default"], {
        show: this.state.showStatusModal,
        onClose: this.onStatusClose.bind(this)
      }, this.state.changingStatusInProgress ? _react["default"].createElement(_index.LoadingOverlay, null) : null, _react["default"].createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column"
        }
      }, _react["default"].createElement("p", {
        style: {
          textAlign: "center",
          paddingBottom: 20
        }
      }, "Please note that STOLEN status is irreversable.", _react["default"].createElement("br", null), "Please select the status of the card:"), _react["default"].createElement("div", {
        style: {
          width: 250,
          marginBottom: 20
        }
      }, _react["default"].createElement("select", {
        value: this.state.cardStatus,
        className: "form-control",
        onChange: function onChange(e) {
          return _this5._statusChanged(e);
        }
      }, _react["default"].createElement("option", {
        value: "good"
      }, "All Good"), _react["default"].createElement("option", {
        value: "locked"
      }, "Locked"), _react["default"].createElement("option", {
        value: "lost"
      }, "Lost"), _react["default"].createElement("option", {
        value: "stolen"
      }, "Stolen (irreversible!)"), _react["default"].createElement("option", {
        value: "expired"
      }, "Expired"), _react["default"].createElement("option", {
        value: "restricted"
      }, "Restricted"), _react["default"].createElement("option", {
        value: "security_violation"
      }, "Security Violation"), _react["default"].createElement("option", {
        value: "cardholder_to_contact_issuer"
      }, "Cardholder to contact issuer"), _react["default"].createElement("option", {
        value: "destroyed"
      }, "Card Destroyed"), _react["default"].createElement("option", {
        value: "voided"
      }, "Voided"))), _react["default"].createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      }, _react["default"].createElement("button", {
        onClick: this.onStatusClose.bind(this),
        className: "button-info"
      }, "Cancel"), _react["default"].createElement("button", {
        onClick: function onClick() {
          return _this5._changeCardStatus(card);
        },
        className: "button-info"
      }, "Submit")), this.state.changeStatusMessage ? _react["default"].createElement("div", null, this.state.changeStatusMessage) : null)));
    }
  }]);

  return CardBasicInfo;
}(_react.Component);

var _default = (0, _reactRouter.withRouter)(CardBasicInfo);

exports["default"] = _default;